<template>
  <v-row
    v-if="!isDestinationBlank"
    align="center"
    justify="start"
    no-gutters
  >
    <v-col
      cols="2"
      sm="3"
      md="7"
      lg="5"
      xl="2"
      class="pa-1"
      v-for="destination in params.value"
      :key="destination"
    >
      <v-img
        contain
        :src="destinationImage(destination)"
        aspect-ratio="1"
      ></v-img>
    </v-col>
  </v-row>
</template>

<script>
  import Symphony from '@/assets/destinations/Symphony-Selected.png'
  import Foresite from '@/assets/destinations/Foresite-Selected.png'
  import Lake5 from '@/assets/destinations/Lake5-Selected.png'
  import Krux from '@/assets/destinations/Krux-Selected.png'
  import LiveRamp from '@/assets/destinations/LiveRamp-Selected.png'
  import DirecTV from '@/assets/destinations/DirecTV-Selected.png'
  import Vizio from '@/assets/destinations/Vizio-Selected.png'
  import Canoe from '@/assets/destinations/Canoe-Selected.png'
  import CanoeVOD from '@/assets/destinations/Canoe_VOD-Selected.png'
  import FreeWheel from '@/assets/destinations/Freewheel-Selected.png'
  import GoogleAdManager from '@/assets/destinations/GAM-Selected.png'
  import VideoAmp from '@/assets/destinations/Videoamp-Selected.png'
  import { DESTINATIONS } from '@/appLogic/targets/Constants'

  export default {
    methods: {
      destinationImage(destination) {
        switch (destination) {
          case DESTINATIONS.SYMPHONY:
            return Symphony
          case DESTINATIONS.FORESITE:
            return Foresite
          case DESTINATIONS.LAKE5:
            return Lake5
          case DESTINATIONS.KRUX:
            return Krux
          case DESTINATIONS.LIVERAMP:
            return LiveRamp
          case DESTINATIONS.DIRECTV:
            return DirecTV
          case DESTINATIONS.ATT_TV:
            return DirecTV
          case DESTINATIONS.VIZIO:
            return Vizio
          case DESTINATIONS.CANOE_LINEAR:
            return Canoe
          case DESTINATIONS.CANOE_VOD:
            return CanoeVOD
          case DESTINATIONS.FREEWHEEL:
            return FreeWheel
          case DESTINATIONS.GOOGLE_AD_MANAGER:
            return GoogleAdManager
          case DESTINATIONS.VIDEOAMP:
            return VideoAmp
        }
      },
    },
    computed: {
      isDestinationBlank() {
        return this.destination === DESTINATIONS.BLANK
      },
    },
  }
</script>

<style></style>



// WEBPACK FOOTER //
// DestinationsRenderer.vue?7da504f4